export function obtenerProductoPorId(id) {
  return fetch(`https://www.thecocktaildb.com/api/json/v1/1/lookup.php?i=${id}`)
    .then(data => data.json())
    .then(json => json.drinks[0])
}

export function obtenerProductoRandom() {
  return fetch('https://www.thecocktaildb.com/api/json/v1/1/random.php')
    .then(data => data.json())
    .then(json => json.drinks[0])
}